// Utility function for safe logout that handles postMessage errors
export const safeLogout = async (instance, navigate) => {
  try {
    console.log("Starting logout process...");
    
    // Clear local MSAL state
    const accounts = instance.getAllAccounts();
    accounts.forEach(account => {
      try {
        instance.removeAccount(account);
      } catch (e) {
        console.warn("Error removing account:", e);
      }
    });
    
    instance.setActiveAccount(null);
    
    // Preserve tour completion status before clearing storage
    const tourCompleted = localStorage.getItem('gwc_tour_completed');
    
    // Clear ALL storage
    sessionStorage.clear();
    localStorage.clear();
    
    // Restore tour completion status
    if (tourCompleted) {
      localStorage.setItem('gwc_tour_completed', tourCompleted);
    }
    
    console.log("Local logout complete");
    
    // Navigate to logout page
    window.location.href = "/logout";
  } catch (error) {
    console.error("Logout failed:", error);
    // As last resort, preserve tour status, clear storage and redirect
    const tourCompleted = localStorage.getItem('gwc_tour_completed');
    sessionStorage.clear();
    localStorage.clear();
    if (tourCompleted) {
      localStorage.setItem('gwc_tour_completed', tourCompleted);
    }
    window.location.href = "/logout";
  }
};